<div class="container-full-width">
    <div class="page-container">
        <div class="product-search-container">
            <div class="title">
                YOU SEARCHED FOR <span>{{keyword}} ({{totalElements}} Results)</span>
            </div>
            <div class="listing-wrapper">
                <div fxLayout="row wrap">
                    <div *ngFor="let product of products" class="listing-item-wrapper">
                        <app-product-listing-item [product]="product"></app-product-listing-item>
                    </div>
                </div>
                <app-paginator [currentPage]="currentPage" [totalPage]="totalPageNum" (onPageChange)="onPageChange($event)"></app-paginator>
            </div>
        </div>
    </div>
</div>